/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Dl_Tab_MacosInputs */

const en_pc_dl_tab_macos = /** @type {(inputs: Pc_Dl_Tab_MacosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`macOS`)
};

const zh_pc_dl_tab_macos = /** @type {(inputs: Pc_Dl_Tab_MacosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`macOS`)
};

/**
* | output |
* | --- |
* | "macOS" |
*
* @param {Pc_Dl_Tab_MacosInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_dl_tab_macos = /** @type {((inputs?: Pc_Dl_Tab_MacosInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Dl_Tab_MacosInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_dl_tab_macos(inputs)
	return zh_pc_dl_tab_macos(inputs)
});
export { pc_dl_tab_macos as "pc.dl.tab.macos" }